import { ScriptCommands } from '../../types/dashboard';
import { queryLogAwsCliInstallScript } from '../commands';

export const staticCommandsDataMSSQL: ScriptCommands = {
  saveSchemaToFile: [
    {
      commands: [
        'mssql-scripter -S <server_name> -d <database_name> -U <username> -P <password> --schema-only > schema.sql',
      ],
      title: 'Export Complete MSSQL Schema to file',
      description: 'Command to generate a complete SQL Server schema script. Requires mssql-scripter tool to be installed',
    },
    {
      commands: [
        `sqlpackage /Action:Script 
          /SourceServerName:<server_name> 
          /SourceDatabaseName:<database_name> 
          /SourceUser:<username> 
          /SourcePassword:<password> 
          /TargetFile:schema.sql 
          /p:ScriptData=False 
          /p:ScriptIndexes=True 
          /p:ScriptCheckConstraints=True 
          /p:ScriptTriggers=True`,
      ],
      title: 'Alternative: Export MSSQL Schema using SqlPackage',
      description: 'Alternative to mssql-scripter. Uses Microsoft\'s SqlPackage utility to generate a comprehensive schema.sql file with complete database structure including indexes, constraints, and triggers',
    },
  ],
  saveSchemaInstallScript: [
    {
      commands: ['pip install mssql-scripter'],
      title: 'Install MSSQL Scripter',
      description: 'Install Microsoft\'s official database scripting tool (equivalent to mysqldump for SQL Server)',
    },
    {
      commands: ['mssql-scripter --version'],
      title: 'Verify mssql-scripter installation',
      description: 'Verify that mssql-scripter is properly installed and accessible',
    },
    {
      commands: [
        'dotnet tool install -g microsoft.sqlpackage',
      ],
      title: 'Alternative: Install SqlPackage',
      description: 'Install Microsoft\'s SqlPackage utility using .NET tools (works on Windows, macOS, and Linux). Requires .NET SDK 6.0 or higher',
    },
    {
      commands: ['sqlpackage /version'],
      title: 'Verify SqlPackage installation',
      description: 'Verify that SqlPackage is properly installed and accessible',
    },
  ],
  saveSchemaDownloadScript: [
    {
      commands: ['cd export_schema_mssql'],
      title: 'cd to export_schema_mssql',
      description: 'Navigate to the MSSQL schema export directory',
    },
    {
      commands: [
        'curl -sSL https://install.python-poetry.org | python3 -',
        'poetry install',
        'poetry shell',
      ],
      title: 'Activate virtual env',
      description: '',
    },
    {
      commands: ['exsch --db_name <db_name> -h <host> -p <port> -u <db_user>'],
      title: 'Run script',
      description: 'Execute the schema export script for SQL Server',
    },
  ],
  createQueryLogSection1: [
    {
      commands: [
        `CREATE EVENT SESSION [QueryPerformance] ON SERVER
      ADD EVENT sqlserver.sql_statement_completed(
          ACTION (sqlserver.sql_text, sqlserver.database_name, sqlserver.username)
      )
      ADD TARGET package0.asynchronous_file_target(
          SET filename = 'd:\\rdsdbdata\\log\\xe_query_performance.xel',
          max_file_size = (50)
      );`,
      ],
      title: 'Create Extended Events',
      description:
        'Run this SQL script in the SQL Server terminal to create an extended events session for logging query performance data.',
    },
    {
      commands: [
        'ALTER EVENT SESSION [QueryPerformance] ON SERVER STATE = START;',
      ],
      title: 'Start Extended Event',
      description:
        'Execute this command in the SQL Server terminal to start the query performance logging session.',
    },
  ],

  createQueryLogSection2: [
    {
      commands: [
        // eslint-disable-next-line
        `sqlcmd -S <server_name> -d <database_name> -U <user_name> -Q 
        "SET QUOTED_IDENTIFIER ON; SET ANSI_NULLS ON;
        SELECT 
            event_data.value('(event/@timestamp)[1]', 'DATETIME') AS event_timestamp,
            event_data.value('(event/data[@name=\"duration\"]/value)[1]', 'BIGINT') AS execution_time_ms,
            REPLACE(REPLACE(REPLACE(
              event_data.value('(event/data[@name=\"statement\"]/value)[1]', 'NVARCHAR(MAX)'),
              CHAR(9), ' '
            ), CHAR(13), ' '), CHAR(10), ' ') AS sql_text
        FROM (
            SELECT CAST(event_data AS XML) AS event_data
            FROM sys.fn_xe_file_target_read_file(
              'd:\\rdsdbdata\\log\\xe_query_performance*.xel',
              NULL, NULL, NULL
            )
        ) AS xe_data;" -o "<output_file>.csv" -s"$(printf '\\t')" -W`,
      ],
      title: 'Fetch Query Logs',
      description:
        'Use this command in the terminal after replacing the values for variables for <server_name>, <database_name>, <user_name>, and <output_file> to extract the logged query performance data into a CSV file.',
    },
    {
      commands: [
        'ALTER EVENT SESSION [QueryPerformance] ON SERVER STATE = STOP;',
      ],
      title: 'Stop Extended Event',
      description:
        'Run this SQL command in the SQL Server terminal to stop the query performance logging session.',
    },
    {
      commands: [
        `IF EXISTS (
          SELECT 1
          FROM sys.server_event_sessions 
          WHERE name = 'QueryPerformance'
      )
      BEGIN
          DROP EVENT SESSION QueryPerformance ON SERVER;
      END`,
      ],
      title: 'Drop Extended Event',
      description:
        'Execute this SQL script in the SQL Server terminal to drop the existing query performance logging session.',
    },
  ],

  exportDatabase: [
    {
      commands: [
        '$ aws s3 cp myfolder s3://mybucket/myfolder --recursive',
        'upload: myfolder/file1.txt to s3://mybucket/myfolder/file1.txt',
        'upload: myfolder/subfolder/file.txt to s3://mybucket/myfolder/subfolder/file1.txt',
      ],
      title: 'Copy Files to S3 Bucket',
      description: 'Command to copy files to an S3 bucket recursively',
    },
    {
      commands: [
        '$ aws s3 sync myfolder s3://mybucket/myfolder --exclude # .tmp',
        'upload: myfolder/newfile.txt to s3://mybucket/myfolder/newfile.txt',
      ],
      title: 'Sync Files to S3 Bucket',
      description:
        'Command to sync files to an S3 bucket, excluding temporary files',
    },
  ],
  downloadScript: [
    {
      commands: [
        '$ aws s3 cp myfolder s3://mybucket/myfolder --recursive',
        'upload: myfolder/file1.txt to s3://mybucket/myfolder/file1.txt',
        'upload: myfolder/subfolder/file.txt to s3://mybucket/myfolder/subfolder/file1.txt',
      ],
      title: 'Download Files from S3 Bucket',
      description: 'Command to download files from an S3 bucket recursively',
    },
  ],
  settingUpTheSystemCommandSection1: [
    {
      commands: ['python --version', 'pip --version'],
      title: 'Verify Python Installation',
      description: 'Check that Python 3.11+ and pip are installed and accessible',
    },
  ],
  settingUpTheSystemCommandSection2: [
    {
      commands: ['pip install pipenv --user'],
      title: 'Install pipenv',
      description: 'Install pipenv for virtual environment management',
    },
  ],
  settingUpTheSystemCommandSection3: [
    {
      commands: ['docker --version'],
      title: 'Verify Docker Installation',
      description: '',
    },
  ],
  queryLogExtractionSetupCommand1: [
    {
      commands: ['poetry --version'],
      title: 'Verify Installation of Poetry',
      description: '',
    },
  ],
  queryLogExtractionSetupCommand2: [
    {
      commands: ['python --version'],
      title: 'Verify Python Installation',
      description: '',
    },
  ],
  exportQueryLogsScript: [
    {
      commands: ['cd export_query_logs'],
      title: 'Move to export query logs directory',
      description: '',
    },
    {
      commands: ['poetry shell'],
      title: 'Activate virtual env',
      description: 'Note: Run "poetry install" only once during initial setup if dependencies are not already installed.',
    },
    {
      commands: [
        'export-query-logs --db-type mssql --host <DB_HOSTNAME> --port <DB_PORT> --user <DB_USERNAME> --password <DB_PASSWORD> --database <DB_NAME> --mode export --duration <DURATION_IN_HOURS(DEFAULT: 24)>',
      ],
      title: 'Run script (Export Mode)',
      description: 'Runs the script in export mode: enables logging, waits for the specified duration, then disables logging and exports the logs.',
    },
  ],
  enableQueryLogsScript: [
    {
      commands: ['cd export_query_logs'],
      title: 'Move to export query logs directory',
      description: '',
    },
    {
      commands: ['poetry shell'],
      title: 'Activate virtual env',
      description: 'Note: Run "poetry install" only once during initial setup if dependencies are not already installed.',
    },
    {
      commands: [
        'export-query-logs --db-type mssql --host <DB_HOSTNAME> --port <DB_PORT> --user <DB_USERNAME> --password <DB_PASSWORD> --database <DB_NAME> --mode enable --log-file-path <LOG_FILE_PATH>',
      ],
      title: 'Enable query logging (Step 1)',
      description: 'Creates and starts MSSQL Extended Events session for query logging. Run this command once to start logging. The script will exit immediately after enabling logging.',
    },
  ],
  disableQueryLogsScript: [
    {
      commands: ['cd export_query_logs'],
      title: 'Move to export query logs directory',
      description: '',
    },
    {
      commands: ['poetry shell'],
      title: 'Activate virtual env',
      description: 'Note: Run "poetry install" only once during initial setup if dependencies are not already installed.',
    },
    {
      commands: [
        'export-query-logs --db-type mssql --host <DB_HOSTNAME> --port <DB_PORT> --user <DB_USERNAME> --password <DB_PASSWORD> --database <DB_NAME> --mode disable --output-dir <OUTPUT_DIRECTORY> --log-file-path <LOG_FILE_PATH>',
      ],
      title: 'Disable query logging and export (Step 2)',
      description: 'Stops MSSQL Extended Events session and exports the captured logs to a CSV file. Run this command after some time to stop logging and retrieve the logs.',
    },
  ],
  exportDataAndDeidentificationScript: [
    {
      commands: [
        'sudo apt-get install unzip',
        'unzip script.zip -d <destination_folder>',
      ],
      title: 'Extract the package',
      description: '',
    },
    {
      commands: ['cd export_and_deidentify'],
      title: 'Move to export and deidentification directory',
      description: '',
    },
    {
      commands: [
        'curl -sSL https://install.python-poetry.org | python3 -',
        'poetry install',
        'poetry shell',
      ],
      title: 'Activate virtual env',
      description: '',
    },
    {
      commands: [
        'exdbd --db_name <database_name> --db_schema <schema_name> --db_server <server_name> --db_port <database_port> --db_user <database_username>',
      ],
      title: 'Run script',
      description: 'Execute the export and deidentification script for SQL Server',
    },
  ],
  shareDeidentifiedFileScript: [
    {
      commands: [
        '$ aws s3 cp myfolder s3://mybucket/myfolder --recursive',
        'upload: myfolder/file1.txt to s3://mybucket/myfolder/file1.txt',
        'upload: myfolder/subfolder/file.txt to s3://mybucket/myfolder/subfolder/file1.txt',
      ],
      title: 'Upload Files from S3 Bucket',
      description: 'Command to Upload files from an S3 bucket',
    },
  ],
  queryLogAwsCliInstallScript,
};
